<template>
  <VasionGeneralModal
    id="api-lookup-settings-modal"
    rejectButtonText="Cancel"
    confirmButtonText="Save"
    modalTitle="API Lookup Settings"
    modalType="slot"
    :sync="sync"
    @noButtonClick="cancelClick()"
    @confirmButtonClick="saveClick()"
  >
    <div class="api-lookup-settings-modal">
      <VasionCheckbox
        id="default-lookup-checkbox"
        class="checkbox"
        name="default-lookup-checkbox"
        :checked="defaultLookup"
        @change="defaultLookup = !defaultLookup"
      >
        Default Lookup
      </VasionCheckbox>
      <VasionCheckbox
        id="select-first-record-only-lookup-checkbox"
        class="checkbox"
        name="select-first-record-only-lookup-checkbox"
        :checked="firstRecordOnly"
        @change="firstRecordOnly = !firstRecordOnly"
      >
        Select First Record Only
      </VasionCheckbox>
    </div>
  </VasionGeneralModal>
</template>

<script>
export default {
  name: 'ApiLookupSettingsModal',
  props: {
    sync: {
      type: Boolean,
      default: false,
      required: false,
    },
    configurationData: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      defaultLookup: false,
      firstRecordOnly: false,
      editableData: this.configurationData,
    }
  },
  watch: {
    sync: {
      immediate: true,
      handler(val) {
        if (val) {
          this.defaultLookup = this.editableData?.IsDefault
          this.firstRecordOnly = this.editableData?.FirstRecordOnly
        } else {
          this.defaultLookup = false
          this.firstRecordOnly = false
        }
      },
    },
    configurationData: {
      immediate: true,
      handler(val) {
        this.editableData = val
      },
    },
  },
  methods: {
    cancelClick() {
      this.$emit('closeModal')
    },
    saveClick() {
      const payload = {
        defaultLookup: this.defaultLookup,
        firstRecordOnly: this.firstRecordOnly,
      }
      this.$emit('setSettings', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/vuetify3Breakpoints.scss';

.api-lookup-settings-modal {
  width: 100%;
  height: 300px;

  @include breakpoint(md) {
    width: 500px;
  }
}

::v-deep .checkbox {
  margin-right: 4px;
}
</style>
